import SEO from "../components/SEO";
import BookingForm from "../components/BookingForm";
import { BUSINESS } from "../lib/site";

export default function BookingPage() {
  return (
    <>
      <SEO
        title="Request a Booking | PR7 MOT Centre Adlington"
        description="Request an MOT, service, wheel alignment, vehicle inspection or Ford wet belt replacement at PR7 MOT Centre, Adlington. Or call 01257 786 540."
        path="/booking"
      />

      <section className="relative bg-navy overflow-hidden">
        <div className="absolute inset-0 eng-grid" />
        <div className="container-pr7 relative py-14 lg:py-16">
          <p className="eyebrow-light mb-3">Book Online</p>
          <h1 className="font-heading font-black text-white text-4xl sm:text-5xl tracking-tight">Request a booking</h1>
          <p className="text-pale/70 text-base leading-relaxed mt-4 max-w-2xl">
            Tell us what your vehicle needs and when suits you. We will confirm your appointment by phone or email. Prefer to talk? Call{" "}
            <a href={BUSINESS.phoneHref} className="text-sky font-semibold">{BUSINESS.phone}</a>.
          </p>
        </div>
      </section>

      <section className="section-pad bg-surface">
        <div className="container-pr7 max-w-3xl">
          <div className="bg-white border border-border rounded-lg p-6 sm:p-9 shadow-sm">
            <BookingForm />
          </div>
        </div>
      </section>
    </>
  );
}
